import React, {Fragment} from 'react';
import {TableBody, TableCell, TableHead, TableRow, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import UserAvatar from "../user-avatar/UserAvatar";
import {withLazyDynamicTable} from "../ui/hoc/LazyDynamicTable";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    }
}));


const _UsersList = ({
                        data: users,
                        actionColumn
                    }: any) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.avatarColumn}></TableCell>
                    <TableCell>{t('_Common.Labels.User')}</TableCell>
                    <TableCell className={classes.actionColumn}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {users
                    .map((user: any) => <TableRow key={user.userId}>
                        <TableCell component="th" scope="row" className={classes.avatarColumn}>
                            <UserAvatar userId={user.userId}/>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body1">{user.firstName} {user.lastName}</Typography>
                            <Typography variant="body2"
                                        color={'textPrimary'}>{user.email}</Typography>
                        </TableCell>
                        <TableCell className={classes.actionColumn} align="center">
                            {
                                actionColumn(user)
                            }
                        </TableCell>
                    </TableRow>)}
            </TableBody>
        </Fragment>
    );
};

const UsersList = (properties: any) => {
    const {users} = properties;

    const query = ({
                       filter,
                       page,
                       size
                   }: any) => {
        const filterItems = filter ? filter.split(' ').map((e: any) => e.toLowerCase().trim()) : [];
        const filteredUsers = !filter ? users : users
            .filter((a: any) => filterItems
                .some((f: any) => [a.lastName, a.firstName, a.email]
                    .filter(p => !!p)
                    .some(p => p.toLowerCase().indexOf(f) > -1)
                )
            );

        return Promise.resolve({
            total: filteredUsers.length,
            items: filteredUsers.slice(page * size, page * size + size)
        });
    };
    return withLazyDynamicTable(_UsersList, query, ['users'])(properties)
};


export default UsersList;
